module.exports = __webpack_public_path__ + "static/metro-24ba21f2fd189e9d243f30d56d995c12.png";